import React from "react";

export const CORES = ["#e83c6e", "#3b82f6", "#1fa855", "#f59e0b", "#8b5cf6", "#14b8a6", "#ef4444", "#64748b"];

// Soma por resposta: fração ideal (porcentagem da API) quando o condomínio usa, senão contagem de votos.
export const calcularResultado = pergunta => {
  const total = pergunta.respostas.reduce((s, r) => s + r.votos.length, 0);
  const itens = pergunta.respostas.map((r, i) => {
    const votos = r.votos.length;
    const percentual = pergunta.fracao ? parseFloat(r.porcentagem || 0) : total ? (votos / total) * 100 : 0;
    return { id: r._id, titulo: r.titulo, votos, percentual, cor: CORES[i % CORES.length] };
  });
  const maior = Math.max(0, ...itens.map(i => i.percentual));
  const lideres = maior > 0 ? itens.filter(i => i.percentual === maior) : [];
  return { total, itens, lideres, empate: lideres.length > 1, fracao: !!pergunta.fracao };
};

const RAIO = 54;
const CIRCUNFERENCIA = 2 * Math.PI * RAIO;

export const Rosca = ({ itens, total, rotulo }) => {
  let acumulado = 0;
  return (
    <svg className="vv-rosca" viewBox="0 0 140 140" role="img" aria-label="Gráfico de resultado">
      <circle cx="70" cy="70" r={RAIO} fill="none" stroke="var(--vv-trilho, #e6e9f0)" strokeWidth="18" />
      {total > 0 &&
        itens
          .filter(i => i.percentual > 0)
          .map(i => {
            const comprimento = (i.percentual / 100) * CIRCUNFERENCIA;
            const fatia = (
              <circle
                key={i.id}
                cx="70"
                cy="70"
                r={RAIO}
                fill="none"
                stroke={i.cor}
                strokeWidth="18"
                strokeDasharray={`${comprimento} ${CIRCUNFERENCIA - comprimento}`}
                strokeDashoffset={-acumulado}
                transform="rotate(-90 70 70)"
              >
                <title>{`${i.titulo}: ${i.percentual.toFixed(1)}%`}</title>
              </circle>
            );
            acumulado += comprimento;
            return fatia;
          })}
      <text x="70" y="66" textAnchor="middle" className="vv-rosca-numero">{total}</text>
      <text x="70" y="84" textAnchor="middle" className="vv-rosca-rotulo">{rotulo}</text>
    </svg>
  );
};

const GraficoResultado = ({ pergunta, numero }) => {
  const r = calcularResultado(pergunta);
  return (
    <section className="vv-cartao vv-resultado">
      <span className="vv-rotulo">Pauta {numero}</span>
      <strong className="vv-pergunta-titulo">{pergunta.titulo}</strong>
      {r.total === 0 ? (
        <p className="vv-suave">Nenhum voto registrado nesta pauta.</p>
      ) : (
        <>
          <div className="vv-grafico">
            <Rosca itens={r.itens} total={r.total} rotulo={r.total === 1 ? "voto" : "votos"} />
            <ul className="vv-legenda">
              {r.itens.map(i => (
                <li key={i.id}>
                  <span className="vv-ponto" style={{ background: i.cor }} />
                  <span className="vv-legenda-texto">{i.titulo}</span>
                  <b>{i.percentual.toFixed(r.fracao ? 2 : 1)}%</b>
                </li>
              ))}
            </ul>
          </div>
          <div className="vv-barras">
            {r.itens.map(i => (
              <div key={i.id} className="vv-barra">
                <div className="vv-barra-texto">
                  <span>
                    {i.titulo}
                    {r.lideres.includes(i) && <em className="vv-selo">{r.empate ? "Empate" : "Mais votada"}</em>}
                  </span>
                  <span>{i.votos} voto(s)</span>
                </div>
                <div className="vv-barra-fundo">
                  <div className="vv-barra-valor" style={{ width: `${i.percentual}%`, background: i.cor }} />
                </div>
              </div>
            ))}
          </div>
          {r.fracao && <p className="vv-suave vv-nota">Percentual calculado pela fração ideal das unidades.</p>}
        </>
      )}
    </section>
  );
};

export default GraficoResultado;
